export const USER_FILTER_NONE = "__NONE__";

export const USER_TABLE_STATUS_FILTER_OPTIONS = [
  { id: "enabled", label: "Enabled" },
  { id: "disabled", label: "Disabled" },
];

export function userMatchesStatusColumnFilter(u, selected) {
  if (!selected.length) return true;
  const wantEn = selected.includes("enabled");
  const wantDis = selected.includes("disabled");
  if (wantEn && wantDis) return true;
  if (wantEn && u.enabled) return true;
  if (wantDis && !u.enabled) return true;
  return false;
}

export function userMatchesOrNoneMultiFilter(u, selected, getRowStrings) {
  if (!selected.length) return true;
  const rowStrings = getRowStrings(u);
  const wantsNone = selected.includes(USER_FILTER_NONE);
  const reals = selected.filter((x) => x !== USER_FILTER_NONE);
  const anyReal = reals.some((r) => rowStrings.includes(r));
  const noneOk = wantsNone && rowStrings.length === 0;
  return anyReal || noneOk;
}

export function userCreatedAtTimestampMs(u) {
  const v = u?.created_at;
  if (v == null || v === "") return null;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : null;
}
